module.exports = __webpack_public_path__ + "img/3_139.eabeff5c.png";